<template>
    <div
        id="Container"
        class="widget-container background--card new-card-layout"
    >
        <a href="#" @click.prevent="closeSelf" class="close">
            <svg-rndr svg="close.svg" />
        </a>
        <div class="widget-contents DialogContent">
            <div
                class="widget-contents__inner DialogContentInner card card-new"
            >
                <div class="card-header">
                    <div class="form-row justify-content-center">
                        <div class="col-md-auto py-4">
                            <h1 v-translate>Billing Address</h1>
                        </div>
                    </div>
                </div>

                <div class="card-body px-2 px-sm-0" :class="hasScroll">
                    <form
                        method="POST"
                        :action="$laraRoute('widget.upgrade-subscription')"
                        @submit.prevent="handleForm"
                        aria-label="Set billing address"
                        id="upgrade-subscription-form"
                        ref="form"
                        novalidate
                    >
                        <div class="form-group row">
                            <div class="col-sm-6 offset-sm-4">
                                <Checkbox
                                    :label="
                                        'Same as my home address.' | translate
                                    "
                                    wrapperClass="ml-2"
                                    module="Widget"
                                    modelName="use_home_as_billing"
                                    :changeHandler="useHomeAddress"
                                />
                            </div>
                        </div>
                        <div
                            class="form-group justify-content-center align-items-center row"
                        >
                            <label for="country" class="col-sm-3" v-translate
                                >Country</label
                            >

                            <div
                                class="col-sm-8 col-md-7"
                                v-if="countries.length"
                            >
                                <CountrySelect
                                    :required="true"
                                    :options="countries"
                                    :hasValue="
                                        billing_country
                                            ? billing_country
                                            : false
                                    "
                                    :setCountry="setBillingCountry"
                                    :getIsoCodeFromName="getIsoCodeFromName"
                                    :label="'billing_country'"
                                    :handler="countryHandler"
                                >
                                    <template slot-scope="{ slotKey }">
                                        <span
                                            :data-key="slotKey"
                                            :class="
                                                `iti-flag ${slotKey.toLowerCase()}`
                                            "
                                        ></span
                                        >&nbsp;
                                    </template>
                                </CountrySelect>
                                <InlineError
                                    :errors="errors"
                                    type="billing_country"
                                />
                            </div>
                            <div
                                class="col-sm-8 col-md-7 loader loader--inline"
                                v-else
                            >
                                <loader />
                            </div>
                        </div>
                        <div
                            class="form-group justify-content-center align-items-center row"
                        >
                            <label
                                for="billing_house_name"
                                class="col-sm-3"
                                v-translate
                                >House Name</label
                            >

                            <div class="col-sm-8 col-md-7">
                                <Input
                                    id="billing_house_name"
                                    name="billing_house_name"
                                    :rule="{
                                        rules: {
                                            required: user.billing_house_number
                                                ? false
                                                : true
                                        }
                                    }"
                                    model="user.billing_house_name"
                                    module="Widget"
                                />
                            </div>
                        </div>
                        <div
                            class="form-group justify-content-center align-items-center row"
                        >
                            <label
                                for="billing_house_number"
                                class="col-sm-3"
                                v-translate
                                >House Number</label
                            >

                            <div class="col-sm-8 col-md-7">
                                <Input
                                    id="billing_house_number"
                                    name="billing_house_number"
                                    :rule="{
                                        rules: {
                                            required: user.billing_house_name
                                                ? false
                                                : true
                                        }
                                    }"
                                    model="user.billing_house_number"
                                    module="Widget"
                                />
                            </div>
                        </div>
                        <div
                            class="form-group justify-content-center align-items-center row"
                        >
                            <label
                                for="street_address"
                                class="col-sm-3"
                                v-translate
                                >Street Address</label
                            >

                            <div class="col-sm-8 col-md-7">
                                <AutoCompleteInput
                                    id="street_address"
                                    name="billing_street"
                                    model="user.billing_street"
                                    module="Widget"
                                    :autocompleteOptions="predictions"
                                    :emulatePlaceChange="emulatePlaceChange"
                                    :changeHandler="callAutoComplete"
                                />
                            </div>
                        </div>
                        <div
                            class="form-group justify-content-center align-items-center row"
                            v-show="showState()"
                        >
                            <label
                                for="state"
                                class="col-sm-3"
                                v-show="!showCounty()"
                                v-translate
                                >State</label
                            >
                            <label
                                for="state"
                                class="col-sm-3"
                                v-show="showCounty()"
                                v-translate
                                >County</label
                            >

                            <div class="col-sm-8 col-md-7">
                                <Input
                                    :rule="'required'"
                                    validateAs="state"
                                    id="state"
                                    name="billing_state"
                                    errorType="billing_state"
                                    model="user.billing_state"
                                    module="Widget"
                                    :required="true"
                                    :lazy="false"
                                />
                            </div>
                        </div>
                        <div
                            class="form-group justify-content-center align-items-center row"
                        >
                            <label for="city" class="col-sm-3" v-translate
                                >City</label
                            >

                            <div class="col-sm-8 col-md-7">
                                <Input
                                    :rule="'required'"
                                    validateAs="city"
                                    id="city"
                                    name="billing_city"
                                    errorType="billing_city"
                                    model="user.billing_city"
                                    module="Widget"
                                    :required="true"
                                    :lazy="false"
                                />
                            </div>
                        </div>
                        <div
                            class="form-group justify-content-center align-items-center row"
                        >
                            <label
                                for="postcode"
                                class="col-sm-3"
                                v-show="showPostcode()"
                                v-translate
                                >Postcode</label
                            >
                            <label
                                for="postcode"
                                class="col-sm-3"
                                v-show="!showPostcode()"
                                v-translate
                                >Zipcode</label
                            >

                            <div class="col-sm-8 col-md-7">
                                <Input
                                    :rule="'required'"
                                    validateAs="postcode"
                                    id="postcode"
                                    name="billing_postcode"
                                    errorType="billing_postcode"
                                    model="user.billing_postcode"
                                    module="Widget"
                                    :required="true"
                                    :lazy="false"
                                />
                            </div>
                        </div>
                    </form>
                </div>

                <div class="card-footer">
                    <div class="row justify-content-center">
                        <div class="col-sm-8">
                            <flash-message></flash-message>
                        </div>
                    </div>

                    <div class="row justify-content-center align-items-end">
                        <div class="col-12 col-sm-auto text-center ml-sm-auto">
                            <LoaderedButton
                                :content="'Confirm' | translate"
                                :clickHandler="submitForm"
                                btnClasses="btn btn-primary"
                                type="submit"
                                :isValid="isValid"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";

import widgetMixin from "@M/widgets/dialog";

export default {
    mixins: [widgetMixin],
    data() {
        return {
            original_billing_address: {},
            autocompleteIdentifier: "billing"
        };
    },
    created() {
        this.getOrganisedCountries();

        // State won't have persisted from top-level page, but we can receive it through the widget framework settings key and manually update the state
        this.setSelectedUpgrade(
            this._widgetInstance.privateSettings.selectedUpgrade
        );
        document.addEventListener("autocomplete:place-change", e => {
            this.resetCheckbox();
        });
    },
    computed: {
        ...mapState({
            use_home_as_billing: state => state.Widget.use_home_as_billing,
            usingHomeAsBilling: state =>
                state.Widget.user.profile.use_home_as_billing,
            billing_country: state => state.Widget.user.billing_country,
            billing_house_name: state => state.Widget.user.billing_house_name,
            billing_house_number: state =>
                state.Widget.user.billing_house_number,
            billing_street: state => state.Widget.user.billing_street,
            home_country: state => state.Widget.user.home_country,
            home_house_name: state => state.Widget.user.home_house_name,
            home_house_number: state => state.Widget.user.home_house_number,
            home_street: state => state.Widget.user.home_street,
            home_state: state => state.Widget.user.home_state,
            home_city: state => state.Widget.user.home_city,
            home_postcode: state => state.Widget.user.home_postcode
        }),
        ...mapFields("Widget", [
            "user.billing_state",
            "user.billing_city",
            "user.billing_postcode",
            "use_home_as_billing"
        ]),
        ...mapState(["countries"])
    },
    methods: {
        ...mapActions(["getOrganisedCountries"]),
        ...mapActions("Widget", [
            "resetBillingFields",
            "setBillingFields",
            "initiateSubscriptionUpgrade"
        ]),
        ...mapMutations("Widget", [
            "setBillingCountry",
            "setUseHomeAsBilling",
            "setSelectedUpgrade"
        ]),
        resetCheckbox() {
            this.use_home_as_billing = true;
        },
        showPostcode: function() {
            return (
                this.user.billing_country == "United Kingdom" ||
                typeof this.user.billing_country == "undefined"
            );
        },
        showState: function() {
            return (
                this.billing_country == "United States" ||
                this.billing_country == "United Kingdom"
            );
        },
        showCounty() {
            return this.billing_country == "United Kingdom";
        },
        formHandler(e) {
            this.initiateSubscriptionUpgrade();
        },
        useHomeAddress: function() {
            let checked = this.use_home_as_billing;

            if (checked) {
                this.setBillingFields({
                    billing_country: this.home_country,
                    billing_postcode: this.home_postcode,
                    billing_city: this.home_city,
                    billing_house_name: this.home_house_name,
                    billing_house_number: this.home_house_number,
                    billing_street: this.home_street,
                    billing_state: this.home_state
                });
            } else {
                this.setBillingFields({
                    billing_country: this.original_billing_address.country,
                    billing_postcode: this.original_billing_address.postcode,
                    billing_city: this.original_billing_address.city,
                    billing_house_name: this.original_billing_address
                        .house_name,
                    billing_house_number: this.original_billing_address
                        .house_number,
                    billing_street: this.original_billing_address.street,
                    billing_state: this.original_billing_address.state
                });
            }
        },
        countryHandler(e, firstRun = false) {
            let val = e.value || e.target.value;
            this.getIsoCodeFromName(val, this.countries);
            this.setBillingCountry(val);
            this.resetCheckbox();
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/UpgradeSubscription.vue